<div class="btn-group btn-group-toggle">
  <label [ngClass]="checkboxClasses" ngbButtonLabel>
    <input type="checkbox" class="checkbox" ngbButton [(ngModel)]="isChecked" [disabled]="disabled">
    <span class="icon-checked icon-checked-ok">
      <fa-icon [icon]="['fal', 'check']" size="sm"></fa-icon>
    </span>
  </label>
</div>